import { formatNumToStandardNotation } from '@modules/common/utils';
import { Stack, Typography } from '@mui/material';

interface SearchAnalysesFeedbackListHeaderProps {
  totalFeedbacks?: number;
  title?: string;
}

export const SearchAnalysesFeedbackListHeader = ({
  totalFeedbacks,
  title = 'Feedback Records',
}: SearchAnalysesFeedbackListHeaderProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
    >
      <Typography variant="h6">
        {title}
        {totalFeedbacks !== undefined
          ? ` (${formatNumToStandardNotation(totalFeedbacks)})`
          : ''}
      </Typography>
    </Stack>
  );
};
